const UserStorageKey = "user-key"
const TeamNumStorageKey = "team-key"

export class Utils {
    static isInitTeam(): boolean{
        const json = localStorage.getItem(TeamNumStorageKey)
        return json != null;
    }
    static SetTeamNum(teamNum: TeamNum){
        localStorage.setItem(TeamNumStorageKey, JSON.stringify(teamNum))
    }
    static getCurrentTeamNum(): TeamNum | null {
        const json = localStorage.getItem(UserStorageKey)

        if (json == null) {
            return null
        }
        const teamNum = JSON.parse(json)
        return teamNum as TeamNum
    }

    static isLogin(): boolean {
        const json = localStorage.getItem(UserStorageKey)
        return json != null;
    }
    static SetUser(user: User) {
        localStorage.setItem(UserStorageKey, JSON.stringify(user))
    }

    static Logout() {
        localStorage.removeItem(UserStorageKey)
    }

    static getCurrentUser(): User | null {
        const json = localStorage.getItem(UserStorageKey)

        if (json == null) {
            return null
        }
        const user = JSON.parse(json)
        return user as User
    }

}